import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { styled } from "@mui/system";
import { Chips } from "./Chips";
import {
  BORDER_PRIMARY,
  DISPLAY_FLEX,
  FLEX_DIRECTION_ROW,
  FLEX_JUSTIFY_CENTER,
  FLEX_JUSTIFY_SPACE_BETWEEN,
} from "../config/styles";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import { RefreshLogo } from "../assets/icons";
import { colors } from "../config/colors";
import { CustomCheckbox } from "./CustomCheckbox";

const CustomizeColumnsStyled = styled(Modal)(({ theme }) => ({
  "& .modal-width-half": {
    width: "436px !important",
  },
  "& .modal-header-text": {
    ...theme.typography.body2,
    width: "95%",
    border: "none",
  },
  "& .create-button-btn": {
    color: theme.palette.secondary.contrastText,
    backgroundColor: theme.palette.primary.main,
    border: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  "& .edit-button-btn": {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.secondary.contrastText,
    border: BORDER_PRIMARY,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  "& .modal-button-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_JUSTIFY_CENTER,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
  },
}));

export const CustomizeColumns = ({
  show,
  handleHide,
  handleSave,
  allFieldsName = [],
  onChange,
  selectedFields = [],
}) => {
  return (
    <CustomizeColumnsStyled
      show={show}
      onHide={handleHide}
      dialogClassName="modal-width-half"
      aria-labelledby="example-custom-modal-styling-title"
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="example-custom-modal-styling-title"
          className="modal-header-text"
        >
          Customize Columns
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column gap-4 w-100">
          <Typography variant="h5">View the list of added columns</Typography>
          <div>
            {selectedFields.map((item, i) => (
              <Grid item spacing={2} key={item + i}>
                <Chips disabled index={1} label={item} />
              </Grid>
            ))}
          </div>
          <div className="d-flex justify-content-between">
            <Typography variant="h5">
              Select custom columns from the list below.
            </Typography>
            <button
              className="d-flex gap-2"
              style={{ border: "none", background: "transparent" }}
              onClick={() => onChange([])}
            >
              <RefreshLogo />
              <Typography variant="body1" sx={{ color: colors.primary }}>
                Reset
              </Typography>
            </button>
          </div>
          <div>
            {allFieldsName.map((item, i) => (
              <div style={{ marginLeft: 8, height: 40 }} key={item + i}>
                <CustomCheckbox
                  label={item}
                  isChecked={selectedFields.includes(item)}
                  onChange={() => {
                    const index = selectedFields.indexOf(item);
                    if (index > -1) {
                      selectedFields.splice(index, 1);
                      onChange(selectedFields);
                    } else {
                      onChange([...selectedFields, item]);
                    }
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-button-container">
        <Button
          className="edit-button-btn"
          onClick={handleHide}
          style={{ width: "45%" }}
        >
          Cancel
        </Button>
        <Button
          className="create-button-btn"
          onClick={handleSave}
          style={{ width: "45%" }}
        >
          Save
        </Button>
      </Modal.Footer>
    </CustomizeColumnsStyled>
  );
};

CustomizeColumns.propTypes = {
  show: PropTypes.bool.isRequired,
  handleHide: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  allFieldsName: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  selectedFields: PropTypes.arrayOf(PropTypes.string),
};
